var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 262,
    viewBox: "0 0 29 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5226 246.315L14.5225 15.457",
    stroke: "url(#paint0_linear_35_10)",
    strokeWidth: 3.04428,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5225 234.138C22.0885 234.138 28.2218 240.271 28.2218 247.837C28.2218 255.403 22.0885 261.536 14.5225 261.536C6.95663 261.536 0.823242 255.403 0.823242 247.837C0.823242 240.271 6.95663 234.138 14.5225 234.138Z",
    fill: "#F0E2B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5225 175.281C22.0885 175.281 28.2218 181.414 28.2218 188.98C28.2218 196.546 22.0885 202.68 14.5225 202.68C6.95663 202.68 0.823242 196.546 0.823242 188.98C0.823242 181.414 6.95663 175.281 14.5225 175.281Z",
    fill: "#E4D29F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5225 116.426C22.0885 116.426 28.2218 122.559 28.2218 130.125C28.2218 137.691 22.0885 143.824 14.5225 143.824C6.95663 143.824 0.823242 137.691 0.823242 130.125C0.823242 122.559 6.95663 116.426 14.5225 116.426Z",
    fill: "#DBC481"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5225 58.5838C22.0885 58.5838 28.2218 64.7172 28.2218 72.2831C28.2218 79.849 22.0885 85.9824 14.5225 85.9824C6.95663 85.9824 0.823242 79.849 0.823242 72.2831C0.823242 64.7172 6.95663 58.5838 14.5225 58.5838Z",
    fill: "#CAB169"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5225 0.743002C22.0885 0.743002 28.2218 6.87639 28.2218 14.4423C28.2218 22.0082 22.0885 28.1416 14.5225 28.1416C6.95663 28.1416 0.823242 22.0082 0.823242 14.4423C0.823242 6.87639 6.95663 0.743002 14.5225 0.743002Z",
    fill: "#AC903F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_10",
    x1: 14.013,
    y1: 282.846,
    x2: 14.0136,
    y2: 14.4421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0E2B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC903F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsColumn);
export default __webpack_public_path__ + "static/media/dotsColumn.5ca047d5ef84aff575810047b9ac2c19.svg";
export { ForwardRef as ReactComponent };